import Icon from 'snippets/icon/icon'

function PlpReviewRating({ rating, reviewCount, className = 'mb-6' }) {
  const ratingValue = Number(rating)
  const countValue = Number(reviewCount)

  return (
    ratingValue > 0 && (
      <div
        className={`flex items-center gap-1.5 ${className}`}
        aria-label={countValue > 0 ? `Rated ${ratingValue} out of 5 from ${countValue} reviews` : `Rated ${ratingValue} out of 5`}
      >
        <div class="relative flex w-fit items-center" aria-hidden="true">
          <div class="inline-flex space-x-0.5">
            {[...Array(5).keys()].map((index) => (
              <Icon key={index} viewBox="0 0 32 32" name="icon-star-outline" className="w-4 h-4 text-primary" />
            ))}
          </div>
          <div class="absolute left-0 top-0 flex space-x-0.5 overflow-hidden" style={`width: ${Math.round((ratingValue / 5) * 100)}%`}>
            {[...Array(5).keys()].map((index) => (
              <Icon key={index} viewBox="0 0 32 32" name="icon-star-filled" className="h-4 w-4 flex-shrink-0  text-[#666]" />
            ))}
          </div>
        </div>
        {countValue > 0 ? (
          <span class="text-sm text-[#666]" aria-hidden="true">
            ({countValue})
          </span>
        ) : null}
      </div>
    )
  )
}

export default PlpReviewRating
